import Button from '@storeblocks/button';
import { getPartnerBrandFromBaseUrl } from 'App/themes/themes.helpers';
import { RouteName } from 'Features/router';
import React, { ReactElement } from 'react';
import { getBasePath, linkPath } from 'Utils/navigation.utils';
import { getAppText } from 'Utils/text';
import { getBrandedBasePath } from './insuranceViewButtons.helpers';

export function CancelButton({
  policyNumber,
  insuranceProduct,
  disabled,
}: {
  policyNumber: string;
  insuranceProduct: string;
  disabled: boolean;
}): ReactElement {
  const currentBasename = getBasePath();
  const brand = getPartnerBrandFromBaseUrl(currentBasename);

  return (
    <Button
      as="a"
      href={linkPath(
        `/${getBrandedBasePath(brand)}${RouteName.CANCEL_INSURANCE}/${policyNumber}`,
      )}
      data-trackid={`button-start_cancel_insurance_${insuranceProduct}`}
      disabled={disabled}
      rel="noopener noreferrer"
      variant="outlined"
      color="primary"
      padding="8px 24px 8px 0px"
    >
      {getAppText('detailed.button.cancelSubscription')}
    </Button>
  );
}
